import React from "react";
import clsx from "clsx";
import FilterFigure from "./filterFigure.jsx";

// Single-choice filter section. Unlike the checkbox lists this is exclusive: picking an option REPLACES
// the current value rather than adding to it, so the facet always resolves to exactly one query value.
// Options with no availability are rendered disabled rather than dropped, for facets that want to show
// what exists but isn't bookable here; the transfer-type facet sends only types it actually offers.
const FilterRadioItem = ({ option, type, onSelect, selected }) => {
    const inputId = `filter-${type}-${option.key}`;
    const labelClasses = clsx("filter-row__label", { "is-disabled": !option.isAvailable });

    return (
        <div className={clsx("filter-row", { "is-disabled": !option.isAvailable })}>
            <div className="flex h-5 shrink-0 items-center">
                <input
                    onChange={() => onSelect()}
                    checked={selected}
                    disabled={!option.isAvailable}
                    id={inputId}
                    name={`filter-${type}`}
                    type="radio"
                    className="size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 relative"
                />
            </div>
            <label htmlFor={inputId} className={labelClasses}>
                {option.name}
            </label>
            <FilterFigure option={option} />
        </div>
    );
};

const FilterRadioList = ({ model, events }) => {
    // The server marks the current choice, so the control still reflects state on a shared/reloaded URL
    // where the parameter is absent because it's the default.
    const current = events.getValue(model.key) ?? model.options.find((o) => o.selected)?.key;

    return model.options.map((option, optionIdx) => (
        <FilterRadioItem
            option={option}
            selected={current === option.key}
            type={model.key}
            key={optionIdx}
            onSelect={() => events.setOption(model.key, option.key)}
        />
    ));
};
export default FilterRadioList;
